import styled from "@emotion/styled";

export const EllipsisText = styled.div({
  textOverflow: "ellipsis",
  width: "100%",
  maxWidth: "100%",
  whiteSpace: "nowrap",
  overflowX: "hidden",
});
